/**
 * API 接口统一管理
 * 基于 axios 封装的接口调用
 */

import axios from '@/plugins/axios';

// 封装 GET 请求
export const get = (url, params = {}, config = {}) => {
  return axios.get(url, {
    params,
    ...config
  });
};

// 封装 POST 请求
export const post = (url, data = {}, config = {}) => {
  return axios.post(url, data, config);
};

// 封装 PUT 请求
export const put = (url, data = {}, config = {}) => {
  return axios.put(url, data, config);
};

// 封装 DELETE 请求
export const del = (url, params = {}, config = {}) => {
  return axios.delete(url, {
    params,
    ...config
  });
};

// 重新导出 travelInsurance 模块中的所有接口
export * from './travelInsurance';

export default {
  get,
  post,
  put,
  del
};
